import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { Text } from '../../constants/TextConstants'
import { ModalSupport } from './Modals/Support'
import {
  ButtonContainer,
  ButtonAntd,
  ProfileButton,
  PencilButton,
  AuditButton,
  QuestionIcon,
  NavSpanSelected,
  NavSpan
} from './styles'
import { useAlertRedirect } from '../../hooks/useAlertRedirect'
import { useSave } from '../../Context/saveContext'
import { isAdminRole } from '../../utils/utils'
import { PERMISSION_CODES } from '../../constants/permissions'

export const HeaderMenu = ({ defaultNavName, hideEditButton, mail }) => {
  const [openSupport, setOpenSupport] = useState(false)
  const navigate = useNavigate()
  const { show } = useAlertRedirect()
  const { isSaved, userProfile, userPermissions, permissionsQuantity } = useSave()

  const onClick = (target) => {
    if (isSaved) {
      navigate(target, {
        state: {
          email: mail
        },
        replace: true
      })
    } else {
      show(target, { email: mail })
    }
  }

  const NavText = (prop) => {
    return isDefaultNavName(defaultNavName, prop.navName) ? (
      <NavSpanSelected>{prop.navName}</NavSpanSelected>
    ) : (
      <NavSpan>{prop.navName}</NavSpan>
    )
  }

  const isDefaultNavName = (defaultName, navName) =>
    navName !== undefined && navName !== null && defaultName === navName

  return (
    <>
      <ButtonContainer>
        {!mail ? undefined : (
          <ButtonAntd
            $showasselected={isDefaultNavName(defaultNavName, Text.Audit)}
            data-testid='AuditButton'
            type='button'
            onClick={() => onClick('/audit')}>
            <AuditButton size={20} />
            <NavText navName={Text.Audit} />
          </ButtonAntd>
        )}
        <ButtonAntd
          $showasselected={isDefaultNavName(defaultNavName, Text.ViewProfile)}
          type='button'
          onClick={() => onClick('/')}>
          <ProfileButton size={20} />
          <NavText navName={Text.ViewProfile} />
        </ButtonAntd>
        {!hideEditButton ? (
          <ButtonAntd
            $showasselected={isDefaultNavName(defaultNavName, Text.Edit)}
            type='button'
            onClick={() => onClick('/edit')}>
            <PencilButton size={30} />
            <NavText navName={Text.Edit} />
          </ButtonAntd>
        ) : undefined}
        {isAdminRole(userProfile?.userRole, userPermissions.length, permissionsQuantity) ? (
          <ButtonAntd
            $showasselected={isDefaultNavName(defaultNavName, Text.AdminPanel)}
            type='button'
            onClick={() => onClick('/profiles')}>
            <AuditButton size={20} />
            <NavText navName={Text.AdminPanel} />
          </ButtonAntd>
        ) : undefined}
        {userPermissions.includes(PERMISSION_CODES.viewEditLists.code) ? (
          <ButtonAntd
            $showasselected={isDefaultNavName(defaultNavName, Text.SpokenLanguages)}
            type='button'
            onClick={() => onClick('/spoken-languages')}>
            <AuditButton size={20} />
            <NavText navName={Text.SpokenLanguages} />
          </ButtonAntd>
        ) : undefined}
        <Tooltip
          placement='top'
          title={isDefaultNavName(defaultNavName, Text.AdminPanel) ? 'Edit Support' : 'View Support'}>
          <ButtonAntd
            $showasselected={isDefaultNavName(defaultNavName, null)}
            type='button'
            onClick={() => setOpenSupport(true)}>
            <QuestionIcon size={20} data-testid='QuestionIcon' />
          </ButtonAntd>
        </Tooltip>
      </ButtonContainer>
      <ModalSupport
        isAdminTab={isDefaultNavName(defaultNavName, Text.AdminPanel)}
        loginMail={mail}
        open={openSupport}
        setModal={setOpenSupport}
      />
    </>
  )
}

HeaderMenu.propTypes = {
  defaultNavName: PropTypes.string,
  hideEditButton: PropTypes.bool,
  mail: PropTypes.string,
  setAlertModal: PropTypes.func
}
